import AppointmentPhoneSvg from '@assets/images/svg/appointment-phone.svg';
import React from 'react';
import { View } from 'react-native';

export interface AppointmentPhoneIconProps {
  size?: number;
  color?: string;
}

/**
 * Figma phone handset for appointment confirmation details (web).
 * Default color matches original SVG stroke (#4D4D4D).
 */
export function AppointmentPhoneIcon({
  size = 14,
  color = '#4D4D4D',
}: Readonly<AppointmentPhoneIconProps>) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <AppointmentPhoneSvg width={size} height={size} color={color} />
    </View>
  );
}

export default AppointmentPhoneIcon;
